import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import PayOrderRepository from '@/domain/repositories/PayOrderRepository';
import PayOrderDataRepository from '@/data/repositories/PayOrderRequestDataRepository';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.PAY_ORDER_REQUEST });
    const payOrderRepository: PayOrderRepository = new PayOrderDataRepository();
    const payOrderResponse = yield call(
      payOrderRepository.register,
      action.code,
      action.orderId,
      action.transactionId,
      action.email,
      action.payMethod,
      action.brand,
      action.message
    );

    if (!payOrderResponse) {
      yield put({
        type: Types.PAY_ORDER_FAILURE,
        error: 'No se pudo pagar la orden'
      });
      return;
    }

    if (payOrderResponse?.error) {
      yield put({
        type: Types.PAY_ORDER_FAILURE,
        error:
          payOrderResponse?.error ||
          'Ocurrió un error al momento de pagar la orden.'
      });
      return;
    }

    yield put({
      type: Types.PAY_ORDER_SUCCESS,
      data: payOrderResponse
    });
  } catch (error) {
    yield put({
      type: Types.PAY_ORDER_FAILURE,
      error: 'Ocurrió un error al momento de pagar la orden.'
    });
  }
}
